<template>
    <div class="home-empty p-relative">
        <div class="notification" v-if="state.notificationDialog">Sorry, you are not on the HALOLIST and can not join this minting.</div>

        <div v-if="isMobile" class="menu-wrap p-relative">
            <a v-if="!menuOpen" class="nav-toggle-btn p-absolute p-2 home-nav-toggle-btn" href="javascript:void(0);" @click="toggleMenu">
                <svg t="1657800077072" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="21836" width="32" height="32"><path d="M120 904c-31.2 0-56-24.8-56-56s24.8-56 56-56h784c31.2 0 56 24.8 56 56s-24.8 56-56 56H120z m0-336c-31.2 0-56-24.8-56-56s24.8-56 56-56h784c31.2 0 56 24.8 56 56s-24.8 56-56 56H120z m0-336c-31.2 0-56-24.8-56-56s24.8-56 56-56h784c31.2 0 56 24.8 56 56s-24.8 56-56 56H120z" p-id="21837" fill="#ffffff"></path></svg>
            </a>
            <div v-show="menuOpen" class="common-menu-box home-menu-box w-100 p-2">
                <a class="nav-toggle-btn p-absolute p-2 home-nav-toggle-btn" href="javascript:void(0);" @click="toggleMenu">
                    <svg t="1657800688236" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="23923" width="32" height="32"><path d="M553.1392 778.88512l451.61472-451.61472c22.64576-22.64576 22.64576-59.4176 0-82.14016-22.64576-22.64576-59.4176-22.64576-82.14016 0l-410.5472 410.61888-410.61888-410.624c-22.64576-22.64576-59.4176-22.64576-82.14016 0-22.64576 22.64576-22.64576 59.4176 0 82.14016l451.69152 451.69152a58.08128 58.08128 0 0 0 82.14016-0.07168z" fill="#ffffff" p-id="23924"></path></svg>
                </a>
                <div id="nav" class="d-flex space-between common-menu nav nav-box font-willow-leaf">
                    <div class="menu">
                        <div class="menu-item d-block mt-2">
                            <router-link class="hover-hl" to="/gallery">GALLERY</router-link>
                        </div>
                        <div class="menu-item d-block mt-2">
                            <router-link class="hover-hl" to="/mint">MINT</router-link>
                        </div>
                        <div class="menu-item d-block mt-2">
                            <router-link class="hover-hl" to="/haloworld_entry"><img src="../assets/images/hot_icon.png" /> HALOWORLD</router-link>
                        </div>
                        <div class="menu-item d-block mt-2">
                            <router-link class="hover-hl" to="/halo_earn">HALO EARN</router-link>
                        </div>
                        <div class="menu-item d-block mt-2">
                            <a class="hover-hl" target="_blank" href="https://market.lifeform.cc/">MARKET</a>
                        </div>
                        <div class="menu-item d-block mt-2">
                            <a class="hover-hl" target="_blank" href="https://medium.com/@halonft.art-official/haloworld-whitepaper-66e830d72873">WHITEPAPER</a>
                        </div>
                        <div class="menu-item d-block p-relative">
                            <span class="txt-item hover-hl">MORE</span>
                            <div class="sub-menu p-absolute">
                                <router-link class="hover-hl" to="/upgrade">UPGRADE</router-link>
                                <router-link class="hover-hl" to="/staking">STAKING</router-link>
                                <router-link class="hover-hl mt-1" to="/metaverse">HALO METAVERSE</router-link>
                                <router-link class="hover-hl mt-1" to="/protocol">PROTOCOL</router-link>
                                <router-link class="hover-hl mt-1" to="/about">ABOUT US</router-link>
                                <router-link class="hover-hl mt-1" to="/spark">SPARK</router-link>
                            </div>
                        </div>
                        <div class="menu-item d-block mt-2">
                            <a class="align-top hover-path-hl social-link" href="https://twitter.com/HALONFTOFFICIAL" target="_blank">
                                TWITTER
                                <svg t="1649855498945" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="26" height="26"><path d="M928 254.3c-30.6 13.2-63.9 22.7-98.2 26.4 35.4-21.1 62.3-54.4 75-94-32.7 19.5-69.7 33.8-108.2 41.2C765.4 194.6 721.1 174 672 174c-94.5 0-170.5 76.6-170.5 170.6 0 13.2 1.6 26.4 4.2 39.1-141.5-7.4-267.7-75-351.6-178.5-14.8 25.4-23.2 54.4-23.2 86.1 0 59.2 30.1 111.4 76 142.1-28-1.1-54.4-9-77.1-21.7v2.1c0 82.9 58.6 151.6 136.7 167.4-14.3 3.7-29.6 5.8-44.9 5.8-11.1 0-21.6-1.1-32.2-2.6C211 652 273.9 701.1 348.8 702.7c-58.6 45.9-132 72.9-211.7 72.9-14.3 0-27.5-0.5-41.2-2.1C171.5 822 261.2 850 357.8 850 671.4 850 843 590.2 843 364.7c0-7.4 0-14.8-0.5-22.2 33.2-24.3 62.3-54.4 85.5-88.2z" p-id="28455" fill="#1d1d1d"></path></svg>
                            </a>
                        </div>
                        <div class="menu-item d-block mt-2">
                            <a class="align-top hover-path-hl social-link" href="https://discord.gg/hjrjkz9r47" target="_blank">
                                DISCORD
                                <svg t="1649857410229" class="icon" viewBox="0 0 1280 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="26" height="26"><path d="M1049.062 139.672a3 3 0 0 0-1.528-1.4A970.13 970.13 0 0 0 808.162 64.06a3.632 3.632 0 0 0-3.846 1.82 674.922 674.922 0 0 0-29.8 61.2 895.696 895.696 0 0 0-268.852 0 619.082 619.082 0 0 0-30.27-61.2 3.78 3.78 0 0 0-3.848-1.82 967.378 967.378 0 0 0-239.376 74.214 3.424 3.424 0 0 0-1.576 1.352C78.136 367.302 36.372 589.38 56.86 808.708a4.032 4.032 0 0 0 1.53 2.75 975.332 975.332 0 0 0 293.65 148.378 3.8 3.8 0 0 0 4.126-1.352A696.4 696.4 0 0 0 416.24 860.8a3.72 3.72 0 0 0-2.038-5.176 642.346 642.346 0 0 1-91.736-43.706 3.77 3.77 0 0 1-0.37-6.252 502.094 502.094 0 0 0 18.218-14.274 3.638 3.638 0 0 1 3.8-0.512c192.458 87.834 400.82 87.834 591 0a3.624 3.624 0 0 1 3.848 0.466 469.066 469.066 0 0 0 18.264 14.32 3.768 3.768 0 0 1-0.324 6.252 602.814 602.814 0 0 1-91.78 43.66 3.75 3.75 0 0 0-2 5.222 782.11 782.11 0 0 0 60.028 97.63 3.728 3.728 0 0 0 4.126 1.4A972.096 972.096 0 0 0 1221.4 811.458a3.764 3.764 0 0 0 1.53-2.704c24.528-253.566-41.064-473.824-173.868-669.082zM444.982 675.16c-57.944 0-105.688-53.174-105.688-118.478s46.818-118.482 105.688-118.482c59.33 0 106.612 53.64 105.686 118.478 0 65.308-46.82 118.482-105.686 118.482z m390.76 0c-57.942 0-105.686-53.174-105.686-118.478s46.818-118.482 105.686-118.482c59.334 0 106.614 53.64 105.688 118.478 0 65.308-46.354 118.482-105.688 118.482z" p-id="1515" fill="#1d1d1d"></path></svg>
                            </a>
                        </div>
                        <div class="menu-item d-block mt-2">
                            <a class="align-top hover-path-hl social-link" href="https://opensea.io/collection/halo-official" target="_blank">
                                OPENSEA
                                <svg class="opensea-icon" width="26" height="26" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M45 0C20.151 0 0 20.151 0 45C0 69.849 20.151 90 45 90C69.849 90 90 69.849 90 45C90 20.151 69.858 0 45 0ZM22.203 46.512L22.392 46.206L34.101 27.891C34.272 27.63 34.677 27.657 34.803 27.945C36.756 32.328 38.448 37.782 37.656 41.175C37.323 42.57 36.396 44.46 35.352 46.206C35.217 46.458 35.073 46.71 34.911 46.953C34.839 47.061 34.713 47.124 34.578 47.124H22.545C22.221 47.124 22.032 46.773 22.203 46.512ZM74.376 52.812C74.376 52.983 74.277 53.127 74.133 53.19C73.224 53.577 70.119 55.008 68.832 56.799C65.538 61.38 63.027 67.932 57.402 67.932H33.948C25.632 67.932 18.9 61.173 18.9 52.83V52.56C18.9 52.344 19.08 52.164 19.305 52.164H32.373C32.634 52.164 32.823 52.398 32.805 52.659C32.706 53.505 32.868 54.378 33.273 55.17C34.047 56.745 35.658 57.726 37.395 57.726H43.866V52.677H37.467C37.143 52.677 36.945 52.299 37.134 52.029C37.206 51.921 37.278 51.813 37.368 51.687C37.971 50.823 38.835 49.491 39.699 47.97C40.284 46.944 40.851 45.846 41.31 44.748C41.4 44.55 41.472 44.343 41.553 44.145C41.679 43.794 41.805 43.461 41.895 43.137C41.985 42.858 42.066 42.57 42.138 42.3C42.354 41.364 42.444 40.374 42.444 39.348C42.444 38.943 42.426 38.52 42.39 38.124C42.372 37.683 42.318 37.242 42.264 36.801C42.228 36.414 42.156 36.027 42.084 35.631C41.985 35.046 41.859 34.461 41.715 33.876L41.661 33.651C41.553 33.246 41.454 32.868 41.328 32.463C40.959 31.203 40.545 29.97 40.095 28.818C39.933 28.359 39.753 27.918 39.564 27.486C39.294 26.82 39.015 26.217 38.763 25.65C38.628 25.389 38.52 25.155 38.412 24.912C38.286 24.642 38.16 24.372 38.025 24.111C37.935 23.913 37.827 23.724 37.755 23.544L36.963 22.086C36.855 21.888 37.035 21.645 37.251 21.708L42.201 23.049H42.219C42.228 23.049 42.228 23.049 42.237 23.049L42.885 23.238L43.605 23.436L43.866 23.508V20.574C43.866 19.152 45 18 46.413 18C47.115 18 47.754 18.288 48.204 18.756C48.663 19.224 48.951 19.863 48.951 20.574V24.939L49.482 25.083C49.518 25.101 49.563 25.119 49.599 25.146C49.725 25.236 49.914 25.38 50.148 25.56C50.337 25.704 50.535 25.884 50.769 26.073C51.246 26.46 51.822 26.955 52.443 27.522C52.605 27.666 52.767 27.81 52.92 27.963C53.721 28.71 54.621 29.583 55.485 30.555C55.728 30.834 55.962 31.104 56.205 31.401C56.439 31.698 56.7 31.986 56.916 32.274C57.213 32.661 57.519 33.066 57.798 33.489C57.924 33.687 58.077 33.894 58.194 34.092C58.554 34.623 58.86 35.172 59.157 35.721C59.283 35.973 59.409 36.252 59.517 36.522C59.85 37.26 60.111 38.007 60.273 38.763C60.327 38.925 60.363 39.096 60.381 39.258V39.294C60.435 39.51 60.453 39.744 60.471 39.987C60.543 40.752 60.507 41.526 60.345 42.3C60.273 42.624 60.183 42.93 60.075 43.263C59.958 43.578 59.85 43.902 59.706 44.217C59.427 44.856 59.103 45.504 58.716 46.098C58.59 46.323 58.437 46.557 58.293 46.782C58.131 47.016 57.96 47.241 57.816 47.457C57.609 47.736 57.393 48.024 57.168 48.285C56.97 48.555 56.772 48.825 56.547 49.068C56.241 49.437 55.944 49.779 55.629 50.112C55.449 50.328 55.251 50.553 55.044 50.751C54.846 50.976 54.639 51.174 54.459 51.354C54.144 51.669 53.892 51.903 53.676 52.11L53.163 52.569C53.091 52.641 52.992 52.677 52.893 52.677H48.951V57.726H53.91C55.017 57.726 56.07 57.339 56.925 56.61C57.213 56.358 58.482 55.26 59.985 53.604C60.039 53.541 60.102 53.505 60.174 53.487L73.863 49.527C74.124 49.455 74.376 49.644 74.376 49.914V52.812V52.812Z" fill="#1d1d1d"/>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="home-frist-tips font-willow-leaf">
            <template v-if="!isMobile && (state.hours || state.mins || state.secs)">
                <p class="end-time-title">Mint Day Count Down</p>
                <p class="end-time">{{ state.hours }}:{{ state.mins }}:{{ state.secs }}</p>
            </template>
            <span class="tip-item mr-5">Powered by Lifeform</span>
            <span class="tip-item">Backed by: 
                <img class="ml-2 align-middle" src="../assets/images/organs/kucoin.png" />
                <img class="ml-4 align-middle" src="../assets/images/organs/geekcartel.png" />
                <img class="ml-4 align-middle" src="../assets/images/organs/the9.png" />
                <img class="ml-4 align-middle" src="../assets/images/organs/markrian.png" />
                <img class="ml-3 align-middle" src="../assets/images/organs/k24.png" />
                <img class="ml-3 align-middle" src="../assets/images/organs/magnet.png" />
            </span>
        </div>
        <div class="time-mobile" v-if="isMobile && (state.hours || state.mins || state.secs)">
            <p class="end-time-title-mobile">Mint Day Count Down</p>
            <p class="end-time-mobile">{{ state.hours }}:{{ state.mins }}:{{ state.secs }}</p>
        </div>
        <!--
        <div class="p-absolute wallet-box">
            <button v-if="!address" class="text-white text-center d-block font-supersonic" @click="connectWallet">CONNECT</button>
            <template v-else>
                <span class="wallet-txt mb-3 text-center text-white d-block font-supersonic">{{ address.substr(0, 6) + '*******' + address.substr(address.length - 4, 4) }}</span>
                <button class="text-center text-white d-block font-supersonic" @click="handleShowMintModal">MINT</button>
            </template>
        </div>
        -->
    </div>
    <div class="video-box w-100 overflow-hidden">
        <div class="video-mask w-100 p-absolute"></div>
        <video class="intro-video w-100 d-inline-block p-relative" :style="vStyle" autoplay loop muted playsinline preload="auto" :poster="require('../assets/images/video_poster.jpg')">
            <source :src="videoSrc" type="video/mp4" />
        </video>
    </div>

    <vue-final-modal v-model="showMintModal" classes="modal-container mint-modal-container" content-class="mint-modal modal-content w-80 border-radius-2">
        <div class="mint-modal-content bg-white p-3">
            <div class="mint-menu border-bottom pb-2 mb-3 clearfix">
                <div class="float-right address-box clearfix">
                    <span v-if="address" class="mint-menu-address float-right border border-hl border-radius-5px pl-3 pr-3 pb-1 font-size-1-5em font-supersonic">{{ address.substr(0, 6) + '*******' + address.substr(address.length - 4, 4) }}</span>
                </div>
                <span class="mint-menu-btn text-center border border-hl border-radius-5px font-size-1-5em font-supersonic d-inline-block mr-4 pb-1 cursor-pointer" :class="modalMenuIndex == 0 ? 'text-white bg-secondary' : ''" @click="changeModalMenu(0)">MINT NOW</span>
                <span class="mint-menu-btn text-center border border-hl border-radius-5px font-size-1-5em font-supersonic d-inline-block pb-1 cursor-pointer" :class="modalMenuIndex == 1 ? 'text-white bg-secondary' : ''" @click="changeModalMenu(1)">MY NFT</span>
            </div>

            <div v-if="modalMenuIndex == 0" class="w-100">
                <div class="clearfix">
                    <div v-if="sellType == 4" class="w-100 text-center">
                        <!--
                        <div class="w-100 mt-4">
                            <div :class="isMobile ? 'w-80 d-block mb-4 ml-auto mr-auto' : 'w-20 d-inline-block'">
                                <img class="w-100 d-block border-primary border-bold border-radius-2" :src="require('../assets/images/mystery_box2.jpg')" />
                            </div>
                        </div>
                        <p class="font-size-2em font-supersonic pt-3 d-block">
                            <a class="text-black pb-1 ml-3" href="https://www.binance.com/en/nft/staking/halonft?ref=466575974" target="_blank" style="border-bottom:1px solid #333333;">Join HALO Launchpad</a>
                            <img class="ml-2 align-middle" style="width:28px;" :src="require('../assets/images/binance.png')" />
                        </p>
                        -->
                        <div class="font-size-2em font-supersonic pt-5 pb-5 d-block">
                            <a class="text-black pb-1" href="https://www.binance.com/en/nft/collection/halo-officialbsc-598778234334724096?orderBy=list_time&orderType=-1&isBack=1&id=598778234334724096&order=list_time%40-1&ref=466575974" target="_blank" style="border-bottom:1px solid #333333;">Go to Binance NFT Marketplace</a>
                            <img class="ml-3 align-middle" style="width:28px;" :src="require('../assets/images/binance.png')" />
                        </div>
                    </div>
                    <div v-else :class="isMobile ? 'w-100' : 'w-80 float-right mr-5'">
                        <div class="mint-box" :class="isMobile ? 'w-80 d-block mb-4 ml-auto mr-auto' : 'w-33 float-left d-inline-block'">
                            <img class="w-100 d-block border-primary border-bold border-radius-2" :src="require('../assets/images/mystery_box.jpg')" />
                            <div v-if="loadingSelltype" class="text-center p-5">
                                <svg v-if="isMobile" t="1650858659733" class="icon loading-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13617" width="26" height="26"><path d="M512 170.666667v85.333333a256 256 0 1 1-223.573333 131.2L213.930667 345.6A341.333333 341.333333 0 1 0 512 170.666667z" fill="#ffffff" p-id="13618"></path></svg>
                                <svg v-else t="1650858659733" class="icon loading-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13617" width="26" height="26"><path d="M512 170.666667v85.333333a256 256 0 1 1-223.573333 131.2L213.930667 345.6A341.333333 341.333333 0 1 0 512 170.666667z" fill="#3a3a3a" p-id="13618"></path></svg>
                                <span class="align-top" style="font-size: 21px">LAODING</span>
                            </div>
                            <template v-else>
                                <div v-show="sellType != 0 && false" class="clearfix mt-3">
                                    <div class="amount-btn d-inline-block cursor-pointer text-center mr-2 align-middle" @click="minusAmount">
                                        <svg t="1650695159507" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11395" width="22" height="22"><path d="M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" p-id="11396" fill="#b5b5b5"></path></svg>
                                    </div>
                                    <input class="mint-amount d-inline-block text-center font-size-1-5em align-middle" v-model="mintAmount" @change="changeMintAmount" />
                                    <div class="amount-btn d-inline-block cursor-pointer text-center ml-2 align-middle" @click="plusAmount">
                                        <svg t="1650695233559" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8338" width="22" height="22">
                                            <path d="M474 152m8 0l60 0q8 0 8 8l0 704q0 8-8 8l-60 0q-8 0-8-8l0-704q0-8 8-8Z" p-id="8339" fill="#b5b5b5"></path>
                                            <path d="M168 474m8 0l672 0q8 0 8 8l0 60q0 8-8 8l-672 0q-8 0-8-8l0-60q0-8 8-8Z" p-id="8340" fill="#b5b5b5"></path>
                                        </svg>
                                    </div>
                                    <div class="float-right eth-box">
                                        <svg v-if="isMobile" t="1650693339819" class="icon align-top" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10302" width="32" height="32">
                                            <path d="M518.336 115.2l-5.1712 17.4976V640.512l5.184 5.12L754.688 506.3424" fill="#d1d1d1" p-id="10304"></path>
                                            <path d="M518.336 115.2L281.984 506.3296l236.352 139.328" fill="#ededed" p-id="10305"></path>
                                            <path d="M518.336 690.304l-2.9184 3.5328V874.752l2.9184 8.448L754.816 551.04" fill="#d1d1d1" p-id="10306"></path>
                                            <path d="M518.336 883.2V690.304L281.984 551.04" fill="#ededed" p-id="10307"></path>
                                            <path d="M518.336 645.6576l236.3264-139.328-236.3264-107.136v246.464" fill="#bdbdbd" p-id="10308"></path>
                                            <path d="M281.984 506.3296l236.3392 139.328V399.1808" fill="#bdbdbd" p-id="10309"></path>
                                        </svg>
                                        <svg v-else t="1650693339819" class="icon align-top" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10302" width="32" height="32">
                                            <path d="M518.336 115.2l-5.1712 17.4976V640.512l5.184 5.12L754.688 506.3424" fill="#343434" p-id="10304"></path>
                                            <path d="M518.336 115.2L281.984 506.3296l236.352 139.328" fill="#8C8C8C" p-id="10305"></path>
                                            <path d="M518.336 690.304l-2.9184 3.5328V874.752l2.9184 8.448L754.816 551.04" fill="#3C3C3B" p-id="10306"></path>
                                            <path d="M518.336 883.2V690.304L281.984 551.04" fill="#8C8C8C" p-id="10307"></path>
                                            <path d="M518.336 645.6576l236.3264-139.328-236.3264-107.136v246.464" fill="#141414" p-id="10308"></path>
                                            <path d="M281.984 506.3296l236.3392 139.328V399.1808" fill="#393939" p-id="10309"></path>
                                        </svg>
                                        <span class="d-inline-block ml-2 align-top font-supersonic font-size-2em" style="margin-top: -7px">{{ mintPrice }}</span>
                                    </div>
                                </div>

                                <div v-if="sellType == 0" class="text-center mt-2">
                                    <p class="font-supersonic font-size-1-5em">COUNT DOWN</p>
                                    <div class="font-ds-digital font-size-4em">
                                        <span class="count-down-txt d-inline-block">{{ countDowmParams.hour.toString().substr(0, 1) }}</span>
                                        <span class="count-down-txt d-inline-block">{{ countDowmParams.hour.toString().substr(1, 1) }}</span>
                                        <span class="d-inline-block">:</span>
                                        <span class="count-down-txt d-inline-block">{{ countDowmParams.min.toString().substr(0, 1) }}</span>
                                        <span class="count-down-txt d-inline-block">{{ countDowmParams.min.toString().substr(1, 1) }}</span>
                                        <span class="d-inline-block">:</span>
                                        <span class="count-down-txt d-inline-block">{{ countDowmParams.sec.toString().substr(0, 1) }}</span>
                                        <span class="count-down-txt d-inline-block">{{ countDowmParams.sec.toString().substr(1, 1) }}</span>
                                    </div>
                                </div>

                                <button v-if="sellType != 0 && sellType != 3" class="mint-btn border-radius-5px text-center d-block w-80 bg-secondary text-white mt-3 ml-auto mr-auto pb-1 font-supersonic font-size-2em" :class="{ disabled: !mintClickable }" @click="handleMint" :disabled="mintClickable ? false : 'disabled'">
                                    <svg v-if="!mintClickable" t="1650858659733" class="icon loading-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13617" width="26" height="26"><path d="M512 170.666667v85.333333a256 256 0 1 1-223.573333 131.2L213.930667 345.6A341.333333 341.333333 0 1 0 512 170.666667z" fill="#ffffff" p-id="13618"></path></svg>
                                    MINT
                                </button>

                                <button v-if="sellType == 3 && isMobile" class="mint-btn border-radius-5px text-dark-gray text-center d-block w-80 bg-light text-white mt-3 ml-auto mr-auto pb-1 font-supersonic font-size-2em" disabled>SOLD OUT</button>
                            </template>
                        </div>
                        <div v-if="sellType == 0" class="roadmap-box d-inline-block align-top float-left text-dark-gray" :class="isMobile ? 'w-100 text-center' : 'w-66 pl-4'">
                            <!-- <div class="clearfix mt-1" :style="isMobile ? 'width: 22em;' : 'width:450px;'" :class="isMobile ? 'ml-auto mr-auto' : ''">
                                <div class="d-inline-block w-100">
                                    <p class="font-supersonic" :class="isMobile ? 'font-size-1-2em' : ' font-size-1-6em'">HALO NFT</p>
                                </div>
                            </div>
                            <p class="mt-2">Reborn in Web3.0, looking for another you.</p>
                            <p class="mt-3 font-supersonic font-size-1-1em">About HALO NFT</p>
                            <p class="mt-2">The HALO label realizes the value in interoperation with the real world through the original economic system and brand effect. Users have a channel of roles to step into the metaverse by holding HALO virtual characters. The character model is not only a static picture but represents another new life that connects with reality. The first HALO SHOW is based on the theme of the Metaverse female competition, and the HALO label will work with the community to govern business routes and commercial events for the favorite virtual female characters to gain more commercial value. All users will indeed meet another new life and a new character in spirit.</p>
                            <p class="mt-3 font-supersonic font-size-1-1em">Details</p> -->
                            <div class="clearfix mt-1" :style="isMobile ? 'width: 100%;' : 'width:450px;'" :class="isMobile ? 'ml-auto mr-auto' : ''">
                                <div class="d-inline-block w-100">
                                    <!-- <p class="font-supersonic" :class="isMobile ? 'font-size-1-3em' : ' font-size-2em'">{{ sellType == 1 ? 'Presale' : 'Public sale' }}</p> -->
                                    <p class="font-supersonic" :class="isMobile ? 'font-size-1-1em' : ' font-size-1-5em'">PRICE: {{ mintPrice }} ETH</p>
                                    <p class="font-supersonic" :class="isMobile ? 'font-size-1-1em' : ' font-size-1-5em'">SUPPLY: 900</p>
                                    <p class="font-supersonic mt-1" :class="isMobile ? 'font-size-1-1em' : ' font-size-1-5em'">CHAIN: Ethereum</p>
                                </div>
                            </div>
                            <p :class="isMobile ? 'mt-2' : 'mt-4'">HALO NFTs, presented in high-definition 3D avatars, are created by the HALO label with the Decentralized 3D Artist Community. HALO NFT owners can easily control the avatar's movements and expressions via live streaming on social platforms like Discord, YouTube and TikTok, or online meetings.</p>
                        </div>

                        <div v-else class="roadmap-box d-inline-block align-top float-left text-dark-gray" :class="isMobile ? 'w-100 text-center' : 'w-66 pl-4'">
                            <div class="clearfix mt-1" :style="isMobile ? 'width: 100%;' : 'width:450px;'" :class="isMobile ? 'ml-auto mr-auto' : ''">
                                <div class="d-inline-block w-100">
                                    <!-- <p class="font-supersonic" :class="isMobile ? 'font-size-1-3em' : ' font-size-2em'">{{ sellType == 1 ? 'Presale' : 'Public sale' }}</p> -->
                                    <p class="font-supersonic" :class="isMobile ? 'font-size-1-1em' : ' font-size-1-5em'">PRICE: {{ mintPrice }} ETH</p>
                                    <p class="font-supersonic" :class="isMobile ? 'font-size-1-1em' : ' font-size-1-5em'">SUPPLY: 900</p>
                                    <p class="font-supersonic mt-1" :class="isMobile ? 'font-size-1-1em' : ' font-size-1-5em'">CHAIN: ETHEREUM</p>
                                </div>
                            </div>
                            <p :class="isMobile ? 'mt-2' : 'mt-4'">HALO NFTs,presented in high-definition 3D avatars,are created by the HALO label with the Decentralized 3D Artist Community.HALO NFT owners can easily control the avatar's movements and expressions on social platforms like Discord, YouTube and TikTok, or online meetings.</p>
                            <!-- <p class="mt-3 font-supersonic font-size-1-1em">UTILITY</p>
                            <p class="mt-2">HALO researched and developed the exclusive tool for virtual humans. The high-definition motion capture technology helps to realize 3D capture and real-time rendering. It supports people to control the movements of virtual humans and express their feelings freely. Meanwhile, this tool helps HALO NFT holders use avatars to socialize on major platforms. Individual IP-used brand image can be realized by operating through we-media like Instagram and TikTok; social media can achieve virtual live stream and interaction like Discord and Twitter; online meeting that is more interactive can be set by office applications like Zoom and Google Meet.</p> -->
                        </div>
                    </div>
                </div>
                <button v-if="sellType == 3 && !isMobile && !loadingSelltype" class="mint-btn border-radius-5px text-center text-dark-gray d-block w-33 bg-light mt-4 ml-auto mr-auto pb-1 font-supersonic font-size-2em" disabled>SOLD OUT</button>
            </div>

            <div v-else class="w-100">
                <div v-if="loadingList" class="text-center p-5">
                    <svg v-if="isMobile" t="1650858659733" class="icon loading-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13617" width="26" height="26"><path d="M512 170.666667v85.333333a256 256 0 1 1-223.573333 131.2L213.930667 345.6A341.333333 341.333333 0 1 0 512 170.666667z" fill="#ffffff" p-id="13618"></path></svg>
                    <svg v-else t="1650858659733" class="icon loading-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13617" width="26" height="26"><path d="M512 170.666667v85.333333a256 256 0 1 1-223.573333 131.2L213.930667 345.6A341.333333 341.333333 0 1 0 512 170.666667z" fill="#3a3a3a" p-id="13618"></path></svg>
                    <span class="align-top" style="font-size: 21px">LAODING</span>
                </div>
                <div v-else-if="state.nftList.length == 0" class="text-center p-5 mt-5 mb-5">
                    <span class="align-top font-supersonic font-size-1-5em">No items to display</span>
                </div>
                <div v-else class="result-list">
                    <div v-for="nft in state.nftList" :key="nft.id" @click="nft.id > state.openedNumber ? showMysteryBox(nft) : getNftInfo(nft)" class="result-item d-inline-block w-20">
                        <div class="img-box w-100 p-relative border-primary border-bold border-radius-2 p-relative overflow-hidden cursor-pointer">
                            <img v-if="nft.id > state.openedNumber" class="item-img w-100 d-block align-bottom" :src="require('../assets/images/mystery_box.jpg')" />
                            <img v-else class="item-img w-100 d-block align-bottom" :src="nft.image" />
                        </div>
                        <p class="font-supersonic font-size-1-5em text-dark-gray text-center">#{{ nft.name }}</p>
                    </div>

                    <!-- <div class="result-item d-inline-block w-20" @click="getNftInfo({id: 1}})">
            <div class="img-box w-100 p-relative border-primary border-bold border-radius-2 p-relative overflow-hidden cursor-pointer">
              <img class="item-img w-100 d-block align-bottom" :src="require('../assets/images/demo_item.png')" />
            </div>
            <p class="font-supersonic font-size-1-5em text-dark-gray text-center">#DEMO</p>
          </div> -->
                </div>
            </div>
        </div>
    </vue-final-modal>

    <vue-final-modal v-model="showHintModal" classes="modal-container hint-modal-container" content-class="hint-modal modal-content w-50 border-radius-2">
        <div v-if="mintStatus == 1" class="text-center p-3">
            <p v-if="!isMobile" class="mint-hint bg-white d-inline-block border border-secondary p-2">CONGRATS! MINTING SUCCEEDED, PLEASE GO TO MY NFT TO CHECK IT</p>
            <div class="bg-secondary border-primary border-bold border-radius-2 p-relative overflow-hidden mt-2 ml-auto mr-auto" :class="isMobile ? 'w-100' : 'w-40'">
                <div class="img-box w-100 p-relative">
                    <img class="item-img w-100 d-block align-bottom" :src="require('../assets/images/mystery_box.jpg')" />
                </div>
            </div>
            <p v-if="isMobile" class="mint-hint bg-white d-inline-block border border-secondary mt-3 p-2">CONGRATS! MINTING SUCCEEDED, PLEASE GO TO MY NFT TO CHECK IT</p>
        </div>
        <div v-if="mintStatus == 2" class="text-center p-3">
            <p class="mint-hint bg-white d-inline-block border border-secondary p-2 font-size-1-5em pl-5 pr-5">{{ state.mintErrorTips ? state.mintErrorTips : 'ERROR! PLEASE TRY LATER' }}</p>
        </div>
    </vue-final-modal>

    <vue-final-modal v-model="showMBModal" classes="modal-container mb-modal-container" content-class="mb-modal modal-content w-20 border-radius-2">
        <div class="text-center p-3">
            <div class="d-inline-block w-100 bg-secondary border-primary border-bold border-radius-2 p-relative overflow-hidden">
                <div class="img-box w-100 p-relative">
                    <img class="mb-img item-img w-100 d-block align-bottom p-absolute" :src="currentOpenNft.id > state.openedNumber ? 'https://ipfs-v2.halonft.art/eth/image/blindbox.png' : currentOpenNft.image" />
                    <img v-if="showOpenMBBtn" class="mb-cover-img w-100 d-block align-bottom p-absolute" :class="showMBCoverImg ? '' : 'mb-img-fadeout'" :src="require('../assets/images/mystery_box.jpg')" />
                </div>
            </div>
            <p class="font-supersonic font-size-2em" :class="isMobile ? 'text-white' : 'text-dark-gray'">#{{ currentOpenNft.name }}</p>
            <!-- <button v-if="showOpenMBBtn" class="border border-hl border-radius-5px text-center d-block w-80 bg-secondary text-white mt-3 ml-auto mr-auto pb-1 font-supersonic font-size-2em open-disable" @click="openMysteryBox">OPEN</button> -->
            <button v-if="showOpenMBBtn" class="border border-hl border-radius-5px text-center d-block w-80 bg-secondary text-white mt-3 ml-auto mr-auto pb-1 font-supersonic font-size-2em open-disable">OPEN</button>
        </div>
    </vue-final-modal>

    <vue-final-modal v-model="state.showNFTModal" classes="modal-container gallery-modal-container" content-class="gallery-modal modal-content w-60 border-radius-2">
        <div class="gallery-modal-content p-relative overflow-y-auto" v-if="state.showNFTModal">
            <img v-if="isMobile" class="item-img w-100 d-block align-bottom" :src="state.nftInfo.image" />
            <img v-else class="item-img w-100 d-block align-bottom" :src="state.nftInfo.image" />
            <div class="w-60 info d-flex items-center font-supersonic pt-2 text-white">
                <p v-if="isMobile" class="pl-3 font-supersonic font-size-2em mb-2">HALO</p>
                <div>
                    <Carousel v-model="state.sliderRef" :items-to-show="isMobile ? 2.2 : 3.5" :snap-align="center">
                        <template v-if="state.nftInfo.validAttr">
                            <Slide v-for="(i, index) in state.nftInfo.validAttr" :key="index">
                                <div class="carousel__item w-100">
                                    <div class="type-item pt-2 pb-2">
                                        <h4>{{ i.trait_type }}</h4>
                                        <p>{{ i.value }}</p>
                                    </div>
                                </div>
                            </Slide>
                        </template>
                        <Slide v-else>
                            <div class="carousel__item w-100">
                                <div class="type-item pt-2 pb-2">
                                    <h4 class="">
                                        <svg v-if="isMobile" t="1650858659733" class="icon loading-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13617" width="26" height="26"><path d="M512 170.666667v85.333333a256 256 0 1 1-223.573333 131.2L213.930667 345.6A341.333333 341.333333 0 1 0 512 170.666667z" fill="#ffffff" p-id="13618"></path></svg>
                                        <svg v-else t="1650858659733" class="icon loading-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13617" width="26" height="26"><path d="M512 170.666667v85.333333a256 256 0 1 1-223.573333 131.2L213.930667 345.6A341.333333 341.333333 0 1 0 512 170.666667z" fill="#ffffff" p-id="13618"></path></svg>
                                    </h4>
                                    <p>LAODING</p>
                                </div>
                            </div>
                        </Slide>
                        <template #addons>
                            <Pagination />
                        </template>
                    </Carousel>
                </div>
                <!-- <div v-else class="w-100 info-box">
                    <template v-if="state.nftInfo?.attributes">
                        <div v-for="(item, i) in state.nftInfo.attributes" :key="i" class="type-item align-top d-inline-block w-45 text-center pt-2 pb-2 mt-2">
                            <h4 class="">{{ item.trait_type }}</h4>
                            <p>{{ item.value }}</p>
                        </div>
                    </template>

                    <div v-else class="type-item align-top d-inline-block w-45 text-center pt-2 pb-2 mt-2">
                        <h4 class="">
                            <svg v-if="isMobile" t="1650858659733" class="icon loading-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13617" width="26" height="26"><path d="M512 170.666667v85.333333a256 256 0 1 1-223.573333 131.2L213.930667 345.6A341.333333 341.333333 0 1 0 512 170.666667z" fill="#ffffff" p-id="13618"></path></svg>
                            <svg v-else t="1650858659733" class="icon loading-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13617" width="26" height="26"><path d="M512 170.666667v85.333333a256 256 0 1 1-223.573333 131.2L213.930667 345.6A341.333333 341.333333 0 1 0 512 170.666667z" fill="#3a3a3a" p-id="13618"></path></svg>
                        </h4>
                        <p>LAODING</p>
                    </div>
                </div> -->
            </div>
        </div>
    </vue-final-modal>

    <vue-final-modal v-model="showChangeChainModal" classes="modal-container change-chain-modal-container" content-class="change-chain-modal modal-content w-50 border-radius-2">
        <div class="bg-white p-4">
            <div class="text-center">
                <p class="font-supersonic font-size-2em">PLEASE MAKE SURE YOUR WALLET NETWORK IS SWITCHED TO ETH.</p>
                <div class="mt-4">
                    <button class="change-network-btn border-radius-5px border-bold border text-muted bg-white font-supersonic font-size-1-5em pt-2 pb-2 mr-2" @click="connectWallet">CANCEL</button>
                    <button class="change-network-btn border-radius-5px border-bold border-hl hl bg-white font-supersonic font-size-1-5em pt-2 pb-2 ml-2" @click="switchToETH">OK</button>
                </div>
            </div>
        </div>
    </vue-final-modal>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, reactive, toRef, getCurrentInstance } from 'vue';
import BigNumber from 'bignumber.js';
import axios from 'axios';
import ChainApi from '../sdk/ChainApi';
import { Carousel, Slide, Pagination } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';

import Web3 from 'web3';

export default {
    name: 'Home',

    components: {
        Carousel,
        Slide,
        Pagination,
    },

    setup() {
        const { proxy } = getCurrentInstance();
        const _global = proxy._global;

        let videoSrc = ref(process.env.VUE_APP_URL + '/web/media/intro.79365dd3.mp4');
        let vStyle = ref(null);
        let menuOpen = ref(false);
        let isMobile = ref(false);
        let vHalf = ref(false);
        let address = ref(false);
        let showMintModal = ref(false);
        let modalMenuIndex = ref(0);
        let mintAmount = ref(1);
        let mintStatus = ref(-1);
        let showHintModal = ref(false);
        let showMBModal = ref(false);
        let showChangeChainModal = ref(false);
        let showOpenMBBtn = ref(false);
        let showMBCoverImg = ref(true);
        let currentOpenNft = ref(0);
        let loadingList = ref(true);
        let loadingSelltype = ref(true);
        let mintClickable = ref(true);
        let countDowmParams = ref({
            hour: '',
            min: '',
            sec: '',
        });

        let sellType = ref(4);
        let mintPrice = ref(0);
        let mintLimit = 0;
        let startTime = 0;
        let hasCheckChain = false;
        
        let ethereum = null;
        // let tempEth = window.ethereum.providers.find((provider) => provider.isMetaMask);
        let tempEth = null;
        if(window.ethereum && window.ethereum.providers && window.ethereum.providers.length) {
            window.ethereum.providers.forEach(provider => {
                if(provider.isMetaMask) {
                    tempEth = provider;
                }
            });
        }
        if(tempEth) {
            ethereum = tempEth;
        }
        else {
            ethereum = window.ethereum;
        }

        let web3 = null;
        let oldChainId = 0;

        const chainApi = ChainApi;

        const state = reactive({
            notificationDialog: false,
            openedNumber: 0,
            nftList: [],

            nftInfo: {},
            showNFTModal: false,
            sliderRef: undefined,

            mintErrorTips: '',
            startTime: '2022/07/12 16:30:00',
            endTime: '2022/07/21 08:00:00',
            timer: '',
            hours: 0,
            mins: 0,
            secs: 0,
        });

        if(ethereum) {
            ethereum.on('accountsChanged', function (accounts) {
                if(!accounts.length) {
                    address.value = null;
                }
            });

            ethereum.on('chainChanged', function (_chainId) {
                console.log(_chainId);
                if(oldChainId == 0) {
                    oldChainId = _chainId;
                    return;
                }

                if(oldChainId != _chainId) {
                    oldChainId = _chainId;
                    if(address.value) {
                        setTimeout(() => {
                            mintInit();
                        }, 200);
                    }
                }
            });
        }

        /*
        const init = async () => {
            if (typeof window.ethereum !== 'undefined') {
                // if(sessionStorage.getItem('wallet_address')) {
                await chainApi.chainWeb3.connect();
                address.value = chainApi.chainWeb3.web3.currentProvider.selectedAddress;
                // }
                // else {
                //   address.value = false;
                // }
                mintInit();
            } else {
                address.value = false;
            }
        };
        */

        const getUTCTime = () => {
            let d1 = new Date();
            let d2 = new Date(d1.getUTCFullYear(), d1.getUTCMonth(), d1.getUTCDate(), d1.getUTCHours(), d1.getUTCMinutes(), d1.getUTCSeconds());
            return Date.parse(d2);
        };

        const dealCountDown = () => {
            const times = new Date(state.startTime).getTime();
            const nowTime = getNowSeconds();

            let timePoor = Math.floor((times - nowTime) / 1000);

            console.log('----', timePoor)

            state.timer = setInterval(() => {
                if (timePoor < 1) {
                    state.hours = 0;
                    state.mins = 0;
                    state.secs = 0;
                    clearInterval(state.timer);
                    return;
                }
                const days = Math.floor(timePoor / 86400);
                state.hours = Math.floor((timePoor % 86400) / 3600) + 24 * days;
                state.mins = Math.floor(((timePoor % 86400) % 3600) / 60);
                state.secs = Math.floor(timePoor % 60);

                state.secs = state.secs - 1;
                if (state.secs === -1) {
                    minusMins();
                    state.secs = 59;
                }
                timePoor--;
            }, 1000);
        };

        const minusMins = () => {
            state.mins = state.mins - 1;
            if (state.mins === -1) {
                minusHours();
                state.mins = 59;
            }
        };

        const minusHours = () => {
            state.hours = state.hours - 1;
            if (state.hours === -1) {
                minusDays();
                statestate.hours = 23;
            }
        };

        const minusDays = () => {
            state.days = state.days - 1;
            if (state.days === -1) {
                state.days = 0;
            }
        };

        const mintInit = async () => {
            try {

                sellType.value = 4;
                /*
                let resParams = await chainApi.haloNFT.parameters();
                sellType.value = resParams.sellType;
                if (sellType.value == 1 || sellType.value == 0) {
                    mintLimit = await chainApi.haloNFT.getPrivateLimit();
                    mintPrice.value = await chainApi.haloNFT.getPrivatePrice();
                } else if (sellType.value == 2) {
                    mintLimit = 20;
                    mintPrice.value = await chainApi.haloNFT.getPublicPrice();
                }
                if (sellType.value == 0) {
                    startTime = Number(resParams.privateStart) * 1000;
                    countDown();
                }

                let totalSupply = await chainApi.haloNFT.totalSupply();
                console.log('totalSupply', totalSupply, 'resParams', new Date().getTime() >= new Date(state.endTime).getTime(), resParams);
                console.log('time', Number(totalSupply) >= Number(resParams.inventory), new Date().getTime(), new Date(state.endTime).getTime(), new Date().getTime() >= new Date(state.endTime).getTime(), Number(totalSupply) >= Number(resParams.inventory) || new Date().getTime() >= new Date(state.endTime).getTime());
                if (Number(totalSupply) >= Number(resParams.inventory) || new Date().getTime() >= new Date(state.endTime).getTime()) {
                    sellType.value = 3;
                }
                */
                loadingSelltype.value = false;
            } catch {
                console.log('something went wrong: get sell type fail');
            }
        };

        const countDown = () => {
            let cur = new Date().getTime();
            if (startTime > cur) {
                // const startTime = 1654372740000;
                // const cur = new Date().getTime();
                var difftime = (startTime - cur) / 1000;
                var days = parseInt(difftime / 86400);
                var hours = parseInt(difftime / 3600) - 24 * days;
                var minutes = parseInt((difftime % 3600) / 60);
                var seconds = parseInt(difftime % 60);

                countDowmParams.value.hour = hours;
                countDowmParams.value.min = minutes;
                countDowmParams.value.sec = seconds;
                // console.log(startTime, difftime, 'days:', days, 'hour', hours, 'min', minutes, 'sec', seconds, new Date(startTime).format('yyyy-MM-dd hh:mm:ss'));

                setTimeout(() => {
                    countDown();
                }, 1000);
            } else {
                sellType.value = 1;
            }
        };

        const switchToETH = async () => {
            await web3.currentProvider.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: web3.utils.toHex('1') }]
            });
            showChangeChainModal.value = false;
            setTimeout(() => {
                window.location.reload();
            }, 100);
        };

        const connectBefore = async () => {
            web3 = new Web3(ethereum);

            showChangeChainModal.value = false;
            let cid = await web3.eth.getChainId();
            if(cid !== 1 && cid !== 56 && !hasCheckChain) {
                hasCheckChain = true;
                showChangeChainModal.value = true;
                return false;
            }
            else {
                hasCheckChain = true;
                connectWallet();
            }
        };

        const connectWallet = async () => {
            if (typeof ethereum === 'undefined') {
                window.open('https://metamask.io/download/', '_blank');
            } else {
                if(!hasCheckChain) {
                    await connectBefore();
                    return;
                }
                showChangeChainModal.value = false;
                await chainApi.chainWeb3.connect();
                address.value = chainApi.chainWeb3.web3.currentProvider.selectedAddress;
                oldChainId = ChainApi.chainWeb3.chainId;
                mintInit();
                return;

                const { VUE_APP_CHAINID, VUE_APP_CHAINID_TIP } = process.env;
                try {
                    await chainApi.chainWeb3.connect();
                    address.value = chainApi.chainWeb3.web3.currentProvider.selectedAddress;

                    const chainId = chainApi.chainWeb3.chainId;
                    if (chainId != VUE_APP_CHAINID) {
                        chainApi.chainWeb3.setupNetwork(VUE_APP_CHAINID).then(res => {
                            console.log('====', res);
                            if (res.code !== 4001 && !res.flag) {
                                // {
                                //     title: 'Select Chain Error',
                                //     message: VUE_APP_CHAINID_TIP,
                                //     type: 'error',
                                // };
                            } else {
                                mintInit();
                            }
                        });
                    } else {
                        mintInit();
                    }
                } catch (e) {
                    console.error('connectWallet ERROR: ', e);
                    // {
                    //     title: 'Select Chain Error',
                    //     message: VUE_APP_CHAINID_TIP,
                    //     type: 'error',
                    // };
                }
            }
        };

        const disConnectWallet = async () => {
            address.value = null;
            await chainApi.chainWeb3.disconnect();
        };

        const handleShowMintModal = async () => {
            showMintModal.value = true;
            loadingList.value = true;
            let list = await chainApi.haloNFT.listMyNFT(address.value);
            let img_type = _global.APP_IMG_TYPE[oldChainId] ? _global.APP_IMG_TYPE[oldChainId] : _global.APP_IMG_TYPE[1];
            state.nftList = list.map(item => ({
                name: item < 100 ? Array(4 - item.length).join(0) + item : item,
                image: ((_global.APP_IMG_URL[oldChainId] ? _global.APP_IMG_URL[oldChainId] : _global.APP_IMG_URL[1]) + '/' + item + '.' + img_type),
                id: item,
            }));
            loadingList.value = false;
        };

        const changeModalMenu = i => {
            modalMenuIndex.value = i;
        };

        const changeMintAmount = () => {
            if (isNaN(mintAmount.value)) {
                mintAmount.value = 1;
            } else if (mintAmount.value < 1) {
                mintAmount.value = 1;
            } else if (mintAmount.value > mintLimit) {
                mintAmount.value = mintLimit;
            } else if (mintAmount.value % 1 !== 0) {
                mintAmount.value = Math.floor(mintAmount.value);
            }
        };

        const minusAmount = () => {
            if (mintAmount.value > 1) {
                mintAmount.value = mintAmount.value - 1;
            }
        };

        const handleMint = async () => {
            try {
                mintClickable.value = false;
                if (sellType.value == 1) {
                    let sign = await chainApi.haloNFT.getSign(address.value);
                    if (sign === ''){
                      state.notificationDialog = true;
                      setTimeout(() => {
                          state.notificationDialog = false;
                      },2500)
                      return 
                    } 
                    let reciept = await chainApi.haloNFT.purchaseWhitelist(new BigNumber(mintAmount.value), sign);
                } else if (sellType.value == 2) {
                    let reciept = await chainApi.haloNFT.purchaseNFT(new BigNumber(mintAmount.value));
                    console.log(reciept);
                }

                mintStatus.value = 1;
                showHintModal.value = true;

                handleShowMintModal();
            } catch (error) {
                mintStatus.value = 2;
                if(error.data && error.data.message) {
                    state.mintErrorTips = error.data.message;
                }
                else {
                    state.mintErrorTips = error.message;
                }
                showHintModal.value = true;
                console.log('error---', error);
            } finally {
                mintClickable.value = true;
            }
        };

        const getNftInfo = async nft => {
            state.nftInfo = {};
            state.nftInfo.image = nft.image;
            state.showNFTModal = true;
            state.sliderRef = 1;
            
            let _url =  _global.APP_TOKEN_URL[oldChainId] ? _global.APP_TOKEN_URL[oldChainId] : _global.APP_TOKEN_URL[1];
            
            axios({
                method: 'get',
                url: _url + '/'+ nft.id + '.json'
            })
            .then(function(res) {
                if(res.data) {
                    console.log(res.data)
                    state.nftInfo = res.data;

                    let temp = [];
                    let attr = res.data.attributes;
                    if(attr) {
                        for(var i in attr) {
                            if(attr[i].value != '' && attr[i].value != "none") {
                                temp.push({
                                    trait_type: attr[i].trait_type,
                                    value: attr[i].value
                                });
                            }
                        }
                    }
                    state.nftInfo.validAttr = temp;
                }
            })
            .catch(function(err) {
                console.log(err);
            });
           /*
            fetch(`${process.env.VUE_APP_URL}/eth/token/${nft.id}.json?t=${new Date().getTime()}`)
            .then(res => res.json())
            .then(data => {
                state.nftInfo = data;
                let attr = data.attributes;
                if(attr) {
                    for(var i in attr) {
                        if(attr[i].value != '' && attr[i].value != "none") {
                            temp.push({
                                trait_type: attr[i].trait_type,
                                value: attr[i].value
                            });
                        }
                    }
                }
                state.nftInfo.validAttr = temp;
            })
            .catch(err => {
                console.error(err);
            });
            */
        };

        const plusAmount = () => {
            if (mintAmount.value < mintLimit) {
                mintAmount.value = mintAmount.value + 1;
            }
        };

        const showMysteryBox = nft => {
            console.log(nft);
            currentOpenNft.value = nft;
            showMBModal.value = true;
            showMBCoverImg.value = true;
            showOpenMBBtn.value = true;
        };

        const openMysteryBox = () => {
            showMBCoverImg.value = false;
            setTimeout(() => {
                showOpenMBBtn.value = false;
            }, 1000);
        };

        const setVideoSize = () => {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            let h = document.documentElement.clientHeight || document.body.clientHeight;
            let vHeight, vWidth, vML, vMT;
            let ratio = 1.365;
            if ((1.0 * w) / h > 1.2 || ((((1.0 * h) / 2) * 16) / 9) * ratio < w) {
                vWidth = w * ratio + 'px';
                vHeight = ((1.0 * w * 9) / 16) * ratio + 'px';
                vMT = ((ratio * w * 9) / 16 - h) / 2 + 'px';
                vML = w * 0.17 + 'px';
                vHalf.value = false;
            } else {
                vHeight = h * ratio + 'px';
                vWidth = ((1.0 * h * 16) / 9) * ratio + 'px';
                vMT = (h * 0.171) + 'px';
                vML = (((ratio * h) * 16) / 9 - w) / 2 + 'px';
                vHalf.value = true;
            }
            vStyle.value = 'width:' + vWidth + ';height:' + vHeight + ';margin-top:-' + vMT + ';margin-left:-' + vML;
        };

        const toggleMenu = () => {
            menuOpen.value = !menuOpen.value;
        };

        const checkMobile = () => {
            let windowWidth = document.body.clientWidth || document.documentElement.clientWidth;
            isMobile.value = windowWidth <= 960;
        };

        const getOpenNumber = () => {
            fetch(`/config.json?${new Date().getTime()}`)
                .then(res => res.json())
                .then(res => {
                    const chain_id = sessionStorage.getItem('chain_id');
                    state.openedNumber = res[`openedNumber-${chain_id}`];
                    console.log('openedNumber:', state.openedNumber);
                });
        };

        const getNowSeconds = () => {
            return new Date(new Date().getTime() + new Date().getTimezoneOffset() * 60 * 1000 + 8 * 60 * 60 * 1000).getTime();
        };

        onMounted(async() => {
            if(chainApi.chainWeb3.account && chainApi.chainWeb3.web3 && chainApi.chainWeb3.web3.currentProvider && chainApi.chainWeb3.web3.currentProvider.selectedAddress) {
                hasCheckChain = true;
                await connectBefore();
                address.value = chainApi.chainWeb3.web3.currentProvider.selectedAddress;
                await mintInit();
            }

            getOpenNumber();
            dealCountDown();
            setTimeout(() => {
                checkMobile();
                setVideoSize();
                window.scroll(0, 0);
            }, 100);
            window.addEventListener('resize', () => {
                setVideoSize();
                checkMobile();
            });
        });

        onBeforeUnmount(() => {
            console.log('----beforeDestroy');
            clearInterval(state.timer);
        });

        return {
            videoSrc,
            vStyle,
            menuOpen,
            toggleMenu,
            isMobile,
            vHalf,
            connectWallet,
            address,
            handleShowMintModal,
            showMintModal,
            changeModalMenu,
            modalMenuIndex,
            mintAmount,
            changeMintAmount,
            minusAmount,
            plusAmount,
            showHintModal,
            handleMint,
            showMysteryBox,
            showMBModal,
            sellType,
            loadingSelltype,
            mintPrice,
            mintStatus,
            showMBCoverImg,
            showOpenMBBtn,
            openMysteryBox,
            currentOpenNft,
            loadingList,
            mintClickable,
            countDowmParams,

            state,
            getNftInfo,

            showChangeChainModal,
            switchToETH,
        };
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.notification {
    position: fixed;
    top: 50px;
    left: 50%;
    transform: translateX(-50%);
    max-width: 90%;
    width: auto;
    padding: 10px 15px;
    line-height: 20px;
    font-size: 18px;
    background: #fff;
    color: rgb(226 12 12);
    border-radius: 4px;
    font-family: 'Microsoft YaHei';
    text-align: center;
    z-index: 9999;
}
.home-empty,
.video-box,
.intro-video,
.video-mask,
.home-menu-box {
    height: 100vh;
}

.v-half,
.v-half .intro-video,
.v-half .video-mask {
    height: 50vh;
    overflow: hidden;
}

.home-empty {
    min-height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    margin-top: -65px;
    z-index: 2;
}

.video-box {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
}

.video-mask {
    z-index: 3;
}

.intro-video {
    z-index: 2;
}

.home-logo {
    top: 86vh;
    left: 20px;
    height: 40px;
}

.down-icon {
    bottom: 20px;
    left: 50%;
    margin-left: -32px;
    opacity: 0.6;
    animation: swink 5s linear infinite;
}

@keyframes swink {
    0% {
        opacity: 0.6;
    }
    50% {
        opacity: 0;
    }
    100% {
        opacity: 0.6;
    }
}

.wallet-box {
    bottom: 100px;
    right: 30px;
}

.home-frist-tips {
    color: #ffffff;
    position: absolute;
    bottom: 30px;
    left: 35px;
    font-size: 26px;
}

.home-frist-tips .tip-item img {
    height: 28px;
}

.wallet-box .wallet-txt,
.wallet-box button {
    background: #344251;
    width: 145px;
    font-size: 25px;
    border-radius: 2px;
    padding-bottom: 5px;
}

.wallet-box .wallet-txt {
    font-size: 14px;
    padding-top: 8px;
    padding-bottom: 11px;
}

.mint-menu-btn {
    width: 140px;
}

.amount-btn {
    width: 26px;
    height: 26px;
    border-radius: 13px;
    border: 2px solid #b5b5b5;
}

.mint-amount {
    height: 22px;
    width: 50px;
    border: 1px solid #b5b5b5;
}

.count-down-txt {
    width: 2rem;
}

.roadmap-box {
    margin-top: 50px;
}

.mint-hint {
    box-shadow: 0 0 5px #7452c2;
}

.result-list {
    min-height: 25vh;
    max-height: 80vh;
}

.result-list .result-item {
    width: 15%;
    margin: 20px 2.5%;
}

.mb-modal .img-box {
    padding-top: 100%;
}

.mb-modal .mb-img,
.mb-modal .mb-cover-img {
    top: 0;
    left: 0;
}

.mb-img-fadeout {
    animation: fadeout 1s linear;
}

@keyframes fadeout {
    0% {
        transform: translateY(0%);
        opacity: 1;
    }
    100% {
        transform: translateY(-150%);
        opacity: 0.5;
    }
}

.gallery-modal-content {
    background: rgba(0, 0, 0, 0.5);
}

.gallery-modal .info {
    top: 0;

    height: auto;
    width: 100%;
    display: block;
    align-items: stretch;
    position: relative;
}

.gallery-modal .info-box {
    margin: auto 0;
}

.gallery-modal .type-item {
    background: rgba(0, 0, 0, 0.3);
    margin: 10px 2.5%;
}

.gallery-header h3 {
    border-width: 2px;
}

.loading-icon {
    animation: rotate 2s linear infinite;
}

.open-disable {
    background: #9b97a3;
    cursor: not-allowed;
}

.end-time-title {
    font-size: 28px;
    color: #ffffff;
    line-height: 58px;
}
.end-time {
    font-weight: 500;
    color: #ffffff;
    line-height: 41px;
    font-size: 63px;
    margin: 24px 0 30px;
}
.change-network-btn {
    width: 120px;
}

@keyframes rotate {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

@media screen and (max-width: 960px) {
    .menu .menu-item {
        position: relative;
        height: 30px;
        margin-bottom: 20px;
        margin-left: 60px;
    }

    .menu .txt-item {
        margin-left: 0;
        padding: 0 10px;
    }

    .menu .sub-menu {
        background: none;
        left: 140px;
    }

    .notification {
        width: 90%;
        text-align: center;
        font-size: 15px;
    }
    .home-empty {
        margin-top: -60px;
    }

    .roadmap-box {
        margin-top: -10px;
    }

    .down-icon {
        top: 87vh;
        bottom: auto;
        right: 20px;
        margin-left: auto;
        left: auto;
        opacity: 0.8;
        animation: swink 2s linear infinite;
    }

    .home-frist-tips {
        bottom: 20px;
        left: 10px;
        font-size: 22px;
    }

    .home-frist-tips .tip-item {
        display: block;
        margin-top: 10px;
    }

    .home-frist-tips .tip-item img {
        margin-left: 15px;
        margin-bottom: 10px;
        height: 20px;
    }

    .wallet-box {
        top: 30px;
        bottom: auto;
        right: 20px;
    }

    .mint-modal .mint-modal-content,
    .mint-modal .mint-modal-content p {
        background: none;
        color: #fff !important;
    }

    .mint-modal .mint-menu {
        border: none;
    }

    .mint-menu .address-box {
        float: none;
        padding-bottom: 10px;
        border-bottom: 3px solid #fff;
        margin-bottom: 10px;
    }

    .mint-menu .mint-menu-btn {
        padding-left: 0;
        padding-right: 0;
        margin-right: 0;
        width: 47.5%;
    }

    .mint-menu .mint-menu-btn:last-child {
        margin-left: 5%;
    }

    .result-list {
        min-height: auto;
    }

    .result-list .result-item {
        width: 47.5%;
        margin: 20px 0;
    }

    .result-list .result-item:nth-child(odd) {
        margin-right: 5%;
    }

    .gallery-modal-content {
        background: rgba(0, 0, 0, 0.5);
        display: block;
        padding-top: 145%;
        height: 0;
        overflow: hidden;
    }

    .gallery-modal .item-img {
        position: absolute;
        top: 0;
        display: block;
    }

    .gallery-modal .info {
        top: 70%;
        height: auto;
        width: 100%;
        display: block;
        align-items: stretch;
        position: absolute;
    }

    .gallery-modal .type-item {
        background: rgba(0, 0, 0, 0.3);
        border-radius: 5px;
        font-size: 0.8rem;
    }
    .time-mobile {
        position: absolute;
        top: 0.8rem;
        right: 0.5rem;
        display: inline-block;
        text-align: center;
    }
    .end-time-title-mobile {
        font-size: 1.2rem;
        color: #ffffff;
        font-weight: 500;
    }
    .end-time-mobile {
        font-weight: 500;
        color: #ffffff;
        font-size: 2.4rem;
    }

    .home-menu-box {
        top: 0;
        left: 0;
        background: rgba(255, 255, 255, 0.5);
    }
}
</style>
